module.exports = __webpack_public_path__ + "static/media/silje.3bbd43db.png";